<template>
  <detail
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    :hidden-keys="['status', 'project_domain', 'tenant']" />
</template>

<script>
import {
  getBrandTableColumn,
  getCloudEnvTableColumn,
  getAccountTableColumn,
} from '@/utils/common/tableColumn'

export default {
  name: 'BillshieldDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getCloudEnvTableColumn(),
        getBrandTableColumn(),
        getAccountTableColumn(),
        {
          field: 'product',
          title: this.$t('bill.shield_res_type'),
          slots: {
            default: ({ row }, h) => {
              let list = []
              if (row.product) {
                list = JSON.parse(row.product)
              }
              const ret = list.map(item => {
                if (item.product_name.length > 20) {
                  return (<a-tooltip v-if="tag.length > 20" title={item.product_name}>
                    <a-tag class="mb-1 mt-1">{item.product_name.slice(0, 20)}...</a-tag>
                  </a-tooltip>)
                }
                return <a-tag class="mb-1 mt-1">{item.product_name}</a-tag>
              })
              return [<div>{...ret}</div>]
            },
          },
        },
      ],
    }
  },
  methods: {
  },
}
</script>
